import React, { useEffect, useState, useRef } from 'react'
import * as styles from './sign-up.module.scss';
import { LocalStorage, LocalStorageKeys } from '../../../utils';
import { useLocale, useLocalPath, useSiteQuery, useUrl } from '../../../hooks';
import Img from 'gatsby-image'
import { Link } from 'gatsby';
const SignUp = () => {
    const locale = useLocale()
    const baseUrl = useUrl()
    const [closed, setClosed] = useState(true)
    const close = () => {
        setClosed(true)
        LocalStorage.set(LocalStorageKeys.SIGN_UP_POPUP(locale), "closed")
    }

    const {
        signUpPopupTitle,
        signUpPopupDescription,
        signUpPopupButtonText,
        signUpPopupButtonLink,
        signUpPopupImage,
        signUpPopupBackgroundImage
    } = useSiteQuery()

    useEffect(() => {
        const initialValue = LocalStorage.get(LocalStorageKeys.SIGN_UP_POPUP(locale))
        if (initialValue === null) {
            setClosed(false)
        }
    }, [])

    return (
        <div>
            {signUpPopupBackgroundImage && <div className={`${styles.popup} ${closed && styles.closed}`} >
                <div className={styles.signUpContainer}>
                    <div className={styles.imageContainer}>
                        <Img fluid={signUpPopupImage.fluid} alt={signUpPopupImage.title} />
                    </div>
                    <div className={styles.signUpContent}>
                        <span className={`${styles.closeIcon} `} onClick={() => close()}></span>
                        <h3 className= {`styles.signupTitle`}>{signUpPopupTitle}</h3>
                        <p>
                            {signUpPopupDescription}
                        </p>
                        <Link to={useLocalPath(`/${signUpPopupButtonLink}`)} className={styles.signUpButton} onClick={() => close()}>{signUpPopupButtonText}</Link>
                        {/* <a href="https://www.lipton.com/eg/en/signup.html" className=>Sign me up!</a> */}
                    </div>
                </div>

            </div>}
        </div>
    )
}

export default SignUp